import { render, staticRenderFns } from "./DiagnosesAdd.vue?vue&type=template&id=e8faab78"
import script from "./DiagnosesAdd.vue?vue&type=script&lang=js"
export * from "./DiagnosesAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports